export enum ScreenWidthTypeEnum {
  mobile = 'mobile',
  tablet = 'tablet',
  desktop = 'desktop',
  xl = 'xl',
}
